export const LANGUAGES = ['English', 'Marathi']